// eslint-disable-next-line import/no-cycle
import {
  ConfigurationPanelStructure,
  ConfigurationPanelStructureItemEnum,
  TemplateStructureEnum,
  TabItem, LinkTypeEnum,
  ComponentNameEnum,
  RichTextingCTAActionTypeEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import { setAttribute, setContent, setWhatsappCTAItems } from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getAttributeByName, getContent, getWhatsappCta, isAttributeActive, isVisible, isSmartListExclusionVisible,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getDisplayFieldConfig from '@/components/template-builder/config/fields/display-config';
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import getTextareaVariablesFieldConfig from '@/components/template-builder/config/fields/textarea-variables-config';
// eslint-disable-next-line import/no-cycle
import imageFieldConfig from '@/components/template-builder/config/fields/image-config';
import { validateWhatsappVariablePosition } from '@/components/template-builder/validators';
// eslint-disable-next-line import/no-cycle
import getInputVariablesFieldConfig from '@/components/template-builder/config/fields/input-variables-config';
// eslint-disable-next-line import/no-cycle
import selectionTypeConfig from '@/components/template-builder/config/fields/selection-type-config';
// eslint-disable-next-line import/no-cycle
import getItemListFieldConfig from '@/components/template-builder/config/fields/item-list-config';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import { OperatorType } from '@/types/generated-types/graphql';
// eslint-disable-next-line import/no-cycle
import { UserState } from '@/composables/User';
// eslint-disable-next-line import/no-cycle
import {
  getWhatsappSmartListDisplayedElements,
  getWhatsappSmartListProperty,
  isWhatsappSmartListManualSelection,
  isWhatsappSmartListEnabled,
  hasMoreThanOneCta,
} from '@/components/template-builder/getters/whatsapp-smart-product-list';
// eslint-disable-next-line import/no-cycle
import {
  setWhatsappSmartListDisplayedElements,
  setWhatsappSmartListProperty,
  refreshWhatsappSmartlist,
} from '@/components/template-builder/setters/whatsapp-smart-product-list';

const ctaTypeOptions = [
  LinkTypeEnum.WEB_ADDRESS,
  LinkTypeEnum.CALL_NUMBER,
  LinkTypeEnum.QUICK_REPLY,
];

export const pageTabItemConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.PAGE,
  label: 'templateBuilder.configs.whatsapp',
  tabPanel: {
    label: 'templateBuilder.configs.whatsapp',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.whatsappContent',
        selector: 'body div#spm_body',
        items: [
          {
            label: 'templateBuilder.fields.whatsappImage',
            selector: '{SELECTOR} img.whatsapp-message__image',
            properties: [
              { name: 'src', getter: getAttributeByName, setters: [setAttribute] },
              { name: 'data-show-image', getter: isAttributeActive, setters: [setAttribute] },
            ],
            ...imageFieldConfig,
            displayToggle: true,
            disableHandler: () => isWhatsappSmartListEnabled(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledBySmartList',
            options: {
              ...imageFieldConfig.options,
              remove: true,
              isSrcUrl: true,
            },
          },
          {
            label: 'templateBuilder.fields.whatsappMessage',
            selector: '{SELECTOR} .whatsapp-message__text',
            properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
            ...getTextareaVariablesFieldConfig('Texte de la notification', variables.allVariables, true),
            options: {
              ...getTextareaVariablesFieldConfig('Texte de la notification', variables.allVariables, true).options,
              validator: validateWhatsappVariablePosition,
            },
          },
          {
            label: 'templateBuilder.fields.whatsappCtas',
            selector: '{SELECTOR} .whatsapp-message__cta.whatsapp-message__cta__list',
            properties: [
              {
                name: 'content',
                getter: getWhatsappCta,
                setters: [setWhatsappCTAItems],
              },
            ],
            componentName: ComponentNameEnum.WHATSAPP_CTAS,
            options: {
              ctaTypeOptions,
              variablesList: variables.allVariables,
              actionTypes: [{ label: 'templateBuilder.configs.whatsappCtaOptions.openlink', value: RichTextingCTAActionTypeEnum.OPEN_LINK }],
              hideEmailSubject: true,
              hideEmailBody: true,
            },
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.smartListConfiguration',
        selector: 'body div#spm_body',
        defaultOpen: true,
        items: [
          {
            label: 'templateBuilder.fields.enableSmartList',
            selector: '{SELECTOR}',
            properties: [{
              name: 'enabled',
              getter: getWhatsappSmartListProperty,
              setters: [setWhatsappSmartListProperty],
            }],
            ...getDisplayFieldConfig('enabled', 'false', 'false', 'true'),
            displayToggle: false,
            fieldId: 'enableSmartList',
            enableValue: 'true',
            disableHandler: () => hasMoreThanOneCta(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledByMultipleCtas',
          },
          {
            label: 'templateBuilder.fields.selectionType',
            selector: '{SELECTOR}',
            properties: [
              {
                name: 'engine',
                getter: getWhatsappSmartListProperty,
                setters: [setWhatsappSmartListProperty],
                callbacks: [refreshWhatsappSmartlist],
              },
              {
                name: 'nb_weeks',
                getter: getWhatsappSmartListProperty,
                setters: [setWhatsappSmartListProperty],
                callbacks: [refreshWhatsappSmartlist],
              },
              {
                name: 'ids',
                getter: getWhatsappSmartListProperty,
                setters: [setWhatsappSmartListProperty],
                callbacks: [refreshWhatsappSmartlist],
              },
            ],
            ...selectionTypeConfig,
            parentFieldId: 'enableSmartList',
            isVisible,
          },
          {
            label: 'templateBuilder.fields.productList',
            selector: '{SELECTOR}',
            properties: [
              {
                name: 'excluded_ids',
                getter: getWhatsappSmartListProperty,
                setters: [setWhatsappSmartListProperty],
                callbacks: [refreshWhatsappSmartlist],
              },
            ],
            ...getItemListFieldConfig(
              [],
              'ShopsProducts',
              { id: 'id_shop_product', label: 'name', elementId: 'id_product' },
              'templateBuilder.fields.excludeProducts',
              [
                { field: 'lang', value: UserState.user.lang ?? 'fr', operator: OperatorType.Equals },
                { field: 'active', value: true, operator: OperatorType.Equals },
              ],
              true,
            ),
            parentFieldId: 'enableSmartList',
            isVisible: isSmartListExclusionVisible,
          },
          {
            label: 'templateBuilder.fields.categoryList',
            selector: '{SELECTOR}',
            properties: [{
              name: 'excluded_categories',
              getter: getWhatsappSmartListProperty,
              setters: [setWhatsappSmartListProperty],
              callbacks: [refreshWhatsappSmartlist],
            }],
            ...getItemListFieldConfig(
              [],
              'ShopsProductsCategoriesList',
              { id: 'id_shop_product_category_list', label: 'name', elementId: 'id_category' },
              'templateBuilder.fields.excludeCategories',
              [
                { field: 'lang', value: UserState.user.lang ?? 'fr', operator: OperatorType.Equals },
              ],
            ),
            parentFieldId: 'enableSmartList',
            isVisible: isSmartListExclusionVisible,
          },
          {
            label: 'templateBuilder.fields.manufacturerList',
            selector: '{SELECTOR}',
            properties: [{
              name: 'excluded_manufacturers',
              getter: getWhatsappSmartListProperty,
              setters: [setWhatsappSmartListProperty],
              callbacks: [refreshWhatsappSmartlist],
            }],
            ...getItemListFieldConfig(
              [],
              'ShopsManufacturers',
              { id: 'id_manufacturer', label: 'name', elementId: 'id_manufacturer' },
              'templateBuilder.fields.excludeManufacturers',
              [],
            ),
            parentFieldId: 'enableSmartList',
            isVisible: isSmartListExclusionVisible,
          },
          {
            label: 'templateBuilder.fields.maxDisplayedProducts',
            selector: '{SELECTOR}',
            disableHandler: () => isWhatsappSmartListManualSelection(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledByManualSelection',
            properties: [{
              name: 'nb',
              getter: getWhatsappSmartListProperty,
              setters: [setWhatsappSmartListProperty],
              callbacks: [refreshWhatsappSmartlist],
            }],
            ...getStepperFieldConfig(),
            parentFieldId: 'enableSmartList',
            displayToggle: false,
            isVisible,
          },
          {
            label: 'templateBuilder.fields.displayedElements',
            selector: '{SELECTOR}',
            properties: [
              {
                name: 'displayedElements',
                getter: getWhatsappSmartListDisplayedElements,
                setters: [setWhatsappSmartListDisplayedElements],
                callbacks: [refreshWhatsappSmartlist],
              },
            ],
            componentName: ComponentNameEnum.MULTIDROPDOWN,
            options: {
              list: [
                { label: 'templateBuilder.fields.productTitle', value: 'spm_product_list_element_title' },
                { label: 'templateBuilder.fields.price', value: 'spm_product_list_element_price' },
                { label: 'templateBuilder.fields.description', value: 'spm_product_list_element_description' },
                { label: 'templateBuilder.fields.image', value: 'spm_product_list_element_image' },
              ],
              defaultValue: [],
              mandatoryFields: ['spm_product_list_element_title', 'spm_product_list_element_image'],
            },
            parentFieldId: 'enableSmartList',
            isVisible,
          },
          {
            label: 'templateBuilder.fields.buttonText',
            selector: '#spm_body .whatsapp-smartlist-carousel',
            properties: [{
              name: 'buttonText',
              getter: getWhatsappSmartListProperty,
              setters: [setWhatsappSmartListProperty],
            }],
            ...getInputVariablesFieldConfig('Texte du bouton', variables.allVariables, false, false),
            parentFieldId: 'enableSmartList',
            isVisible,
          },
        ],
      },
    ],
  },
};

const pageItemConfig: ConfigurationPanelStructure = {
  items: [
    pageTabItemConfig,
  ],
};

export default pageItemConfig;
